import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../wayfinder'
import update603324 from './update'
/**
* @see \App\Http\Controllers\SmsController::update
 * @see app/Http/Controllers/SmsController.php:56
 * @route '/account/sms/update'
 */
export const update = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

update.definition = {
    methods: ["post"],
    url: '/account/sms/update',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\SmsController::update
 * @see app/Http/Controllers/SmsController.php:56
 * @route '/account/sms/update'
 */
update.url = (options?: RouteQueryOptions) => {
    return update.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\SmsController::update
 * @see app/Http/Controllers/SmsController.php:56
 * @route '/account/sms/update'
 */
update.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: update.url(options),
    method: 'post',
})

    /**
* @see \App\Http\Controllers\SmsController::update
 * @see app/Http/Controllers/SmsController.php:56
 * @route '/account/sms/update'
 */
    const updateForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
        action: update.url(options),
        method: 'post',
    })

            /**
* @see \App\Http\Controllers\SmsController::update
 * @see app/Http/Controllers/SmsController.php:56
 * @route '/account/sms/update'
 */
        updateForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
            action: update.url(options),
            method: 'post',
        })
    
    update.form = updateForm
const sms = {
    update: Object.assign(update, update603324),
}

export default sms